export default [
  {
    path: '/private-car-list',
    name: 'carList',
    component: () => import('@/views/administration/carList/list'),
    children:[
      {
        path: 'class-list',
        name: 'classList',
        component: () => import('@/views/administration/carList/class-list'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'manage-class',
        name: 'manageClass',
        component: () => import('@/views/administration/carList/manage-class'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'manage-model/:make',
        name: 'manageModel',
        component: () => import('@/views/administration/carList/manage-model'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: 'manage-make',
        name: 'manageMake',
        component: () => import('@/views/administration/carList/manage-make'),
        meta: {
          keepAlive: false
        }
      },
    ],
    meta: {
      keepAlive: false
    }
  },
]
